import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { posApi, formatApiError } from '@/lib/api';
import CustomerActionPanel from '@/components/pos/CustomerActionPanel';
import { toast } from 'sonner';
import { ArrowLeft, Search } from 'lucide-react';

export default function PosSearch() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(null);

  const search = async (value) => {
    setQ(value);
    if (!value.trim()) return setResults([]);
    try {
      const { data } = await posApi.get('/customers', { params: { q: value, pageSize: 10 } });
      setResults(data.customers);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const select = (customer) => {
    setSelected({ customer, subscription: customer.latestSubscription });
  };

  return (
    <div className="min-h-screen bg-obsidian px-6 py-8 flex flex-col items-center">
      <div className="w-full max-w-md flex items-center gap-3 mb-6">
        <button data-testid="pos-search-back-btn" onClick={() => navigate('/pos/home')} className="text-white/60 hover:text-white">
          <ArrowLeft size={22} />
        </button>
        <h1 className="font-heading text-xl font-semibold text-white">Search Customer</h1>
      </div>

      <div className="w-full max-w-md space-y-3">
        {!selected && (
          <>
            <div className="relative">
              <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-ink" />
              <input
                data-testid="pos-search-input"
                value={q}
                onChange={(e) => search(e.target.value)}
                placeholder="Phone, name, email or customer ID"
                autoFocus
                className="w-full h-14 rounded-xl pl-11 pr-4 text-lg bg-white text-charcoal"
              />
            </div>

            <div className="space-y-2">
              {results.map((c) => (
                <button
                  key={c.id}
                  data-testid={`pos-search-result-${c.id}`}
                  onClick={() => select(c)}
                  className="w-full bg-white/10 hover:bg-white/20 rounded-xl p-4 text-left transition-colors duration-150"
                >
                  <p className="text-white font-medium">{c.name}</p>
                  <p className="text-white/50 text-sm">{c.phone} · {c.latestSubscription?.plan?.name || 'No plan'}</p>
                </button>
              ))}
              {q && results.length === 0 && <p className="text-white/40 text-sm text-center pt-4">No customers found.</p>}
            </div>
          </>
        )}

        {selected && (
          <CustomerActionPanel
            customer={selected.customer}
            subscription={selected.subscription}
            onReset={() => {
              setSelected(null);
              setResults([]);
              setQ('');
            }}
          />
        )}
      </div>
    </div>
  );
}
